/**
 * ブランドロゴの 1 枚シートを再生成してサーバーに保存する (非ブロッキング想定)。
 *
 * ロゴの追加/編集/削除/並べ替え後、および未生成ブランドのバックフィル時に呼ぶ。
 * 競合防止はサーバー側の楽観ロックに委ねる: GET 応答由来の `sourceToken` をそのまま
 * 添えて送り、サーバーが現在トークンと照合して一致時のみ反映する
 * (不一致＝より新しい変更がある場合は skip され、その変更が誘発する再生成が最新を作る)。
 */
import { apiClient } from '../../services/apiClient';
import { renderBrandLogoSheetBlob, type LogoSheetLogo } from './renderLogoSheet';

export async function regenerateBrandLogoSheet(
  brandId: string,
  logos: LogoSheetLogo[],
  sourceToken: string,
  meta?: { brandName?: string },
): Promise<void> {
  // 描画可能なロゴが無ければシートを削除 (0 件運用)
  const result = logos.length > 0 ? await renderBrandLogoSheetBlob(logos, meta) : null;

  if (!result) {
    await apiClient.delete(`/brands/${brandId}/logo-sheet`, {
      params: { source_token: sourceToken },
    });
    return;
  }

  const form = new FormData();
  form.append('file', new File([result.blob], `${brandId}.png`, { type: 'image/png' }));
  form.append('source_token', sourceToken);
  await apiClient.post(`/brands/${brandId}/logo-sheet`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
